import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { cn } from 'utils/cn';
import { useAiChatOptionPick } from '../aiChatOptionPickContext';

/**
 * The line at the top of a conversation while its connection is unstable. It drops into place (the toast recipe),
 * stays while the condition holds, and is announced once through the conversation's status region, which it reaches
 * through the option-pick context. Sticky, so the surface's scroller pads its top by the banner's height meanwhile.
 */
export default function AiChatConnectionBanner() {
    const intl = useIntl();
    const { announce } = useAiChatOptionPick();
    const line = intl.formatMessage({ id: 'ai-chat.error.connection-unstable' });
    // Mounted closed, then opened, so the recipe has a state to move from.
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const frame = requestAnimationFrame(() => setIsOpen(true));
        announce(line);
        return () => cancelAnimationFrame(frame);
        // Announced on appearing only, not again on a re-render that hands a new `announce`.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <p
            data-slot="ai-connection-banner"
            className={cn(
                't-toast bg-warning-tint text-caption text-warning-ink sticky top-0 z-10 m-0 rounded-lg px-3 py-1.5 font-medium',
                isOpen && 'is-open'
            )}
        >
            {line}
        </p>
    );
}
